import {Component, Input} from '@angular/core';
import {Race} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-race-details-summary',
  templateUrl: './race-details-summary.component.html',
  styleUrl: './race-details-summary.component.scss',
  standalone: false
})
export class RaceDetailsSummaryComponent {
  @Input() race?: Race;

  constructor(public translocoService: TranslocoService,) {

  }

}
